var _a, _b;
import { debugLogger } from '../../debug';
var UA = window.navigator.userAgent;
var isAndroid = /android/ig.test(UA);
var isIos = /iphone|ipod/ig.test(UA);
var isWs = /_WEISHI_/i.test(UA);
var isWX = /MicroMessenger/i.test(UA);
var isQQ = / QQ\//i.test(UA);
var isKB = /qnreading/i.test(UA);
var isQZone = /Qzone/i.test(UA);
var isYYB = /qqdownloader/i.test(UA);
var isTV = /QQLiveBrowser\/([\d\.]*)/i.test(UA);
var isQBJS = /MQQBrowser/i.test(UA) && /SogouMSE/i.test(UA);
var isQBNOVEL = /MQQBrowser/i.test(UA) && /SogouSR/i.test(UA);
var isNews = /qqnews\/([\.\d]+)/i.test(UA);
var isTBS = / TBS\//i.test(UA);
var isMiniQB = / MiniQB\//i.test(UA);
var notQBCore = !isWs && !isWX && !isQQ && !isQZone && !isTBS;
var isQB = typeof ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.startDownload) === 'function' || (/MQQBrowser/i.test(UA) && notQBCore);
var iosVersion = /iphone os ([0-9]+)_/ig.exec(UA);
var isOther = !isQB && !isYYB && !isWX && !isTV && !isQQ && !isTBS;
var platformName = [
    isWs && '微视',
    isWX && '微信',
    isQQ && 'QQ',
    isKB && '快报',
    isQZone && 'QQ空间',
    isYYB && '应用宝',
    isTV && '腾讯视频',
    isNews && '腾讯新闻',
    isTBS && 'TBS',
    isQB && 'QQ浏览器',
    isQBJS && '浏览器极速版',
    isQBNOVEL && '搜狗免费小说极速版',
    isOther && '其他',
].filter(function (v) { return v; }).join(',');
export var platformCode = [
    isWs && 'Ws',
    isWX && 'WX',
    isQQ && 'QQ',
    isKB && 'KB',
    isQZone && 'QZone',
    isYYB && 'YYB',
    isTV && 'TV',
    isNews && 'News',
    isTBS && 'TBS',
    isQB && 'QB',
    isQBJS && 'QBJS',
    isQBNOVEL && 'QBNOVEL',
].filter(function (v) { return v; }).join(',');
debugLogger('当前平台:', isIos ? 'IOS' : 'Android');
debugLogger('当前应用:', platformName);
// 检测系统
export default {
    isAndroid: isAndroid,
    isIos: isIos,
    isQB: isQB,
    isQBJS: isQBJS,
    isQBNOVEL: isQBNOVEL,
    isNews: isNews,
    isKB: isKB,
    isQQ: isQQ,
    isWX: isWX,
    isTV: isTV,
    isQZone: isQZone,
    isYYB: isYYB,
    isTBS: isTBS,
    iosVer: iosVersion && iosVersion[1],
    isMiniQB: isMiniQB,
    isWs: isWs,
    isOther: isOther,
};
